import { FilterSelect, SearchInput, SortIcon } from "@marketplace/shared/ui";
import { getRouteApi } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useSortByOptions } from "../../hooks/use-sort-by-options";
import type { ProductListSortValue } from "../../types";

const route = getRouteApi("/products/list/");

export const Filters = () => {
  const { tab, q, sort, draft_q, draft_sort } = route.useSearch();
  const navigate = route.useNavigate();
  const { t } = useTranslation("product");
  const { t: tCommon } = useTranslation("common");

  const isDraftTab = tab === "draft";
  const currentSearch = isDraftTab ? draft_q : q;
  const currentSort = isDraftTab ? draft_sort : sort;

  const [search, setSearch] = useState(currentSearch || "");
  const sortByOptions = useSortByOptions();

  useEffect(() => {
    setSearch(currentSearch || "");
  }, [currentSearch]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (isDraftTab) {
        navigate({
          search: (prev) => ({
            ...prev,
            draft_q: search,
            draft_page: 1
          })
        });
      } else {
        navigate({
          search: (prev) => ({
            ...prev,
            q: search,
            page: 1
          })
        });
      }
    }, 300);

    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handleOrderSearchChange = (value: string) => {
    setSearch(value);
  };

  const handleSortByChange = (value: ProductListSortValue) => {
    if (isDraftTab) {
      navigate({
        search: (prev) => ({
          ...prev,
          draft_q: search,
          draft_page: 1,
          draft_sort: value
        })
      });
    } else {
      navigate({
        search: (prev) => ({
          ...prev,
          q: search,
          page: 1,
          sort: value
        })
      });
    }
  };

  return (
    <div className="flex justify-between items-center mb-6">
      <div>
        <SearchInput
          className="lg:w-[634px]"
          placeholder={t("productListPage.searchPlaceholder")}
          onChange={handleOrderSearchChange}
          value={search}
        />
      </div>
      <div className="flex gap-x-[14px]">
        <FilterSelect
          label={tCommon("sortBy")}
          options={sortByOptions}
          value={currentSort}
          onChange={(v) => handleSortByChange(v as ProductListSortValue)}
          width={179}
          icon={<SortIcon />}
          dropdownPosition="bottom-end"
        />
      </div>
    </div>
  );
};
